export const GET_DIET_PLAN = 'GET_DIET_PLAN'
export const GET_DIET_PLAN_SUCCESS = 'GET_DIET_PLAN_SUCCESS'
export const GET_DIET_PLAN_FAILURE = 'GET_DIET_PLAN_FAILURE'
